import { createAction } from "typesafe-actions";
import { ApiError } from "../types/ApiError";
import { Portfolio } from "../types/portfolio/Portfolio";
import { AddToPortfolioPosition } from "../types/state/AddToPortfolioState";

const setPopupVisibility = createAction('addToPortfolio/POPUP_VISIBLE',
    resolve => (visible: boolean, position?: AddToPortfolioPosition) =>
        resolve({ visible, position })
);

const reset = createAction('addToPortfolio/RESET');

const setSelectedPortfolio = createAction('addToPortfolio/SET_SELECTED_PORTFOLIO',
    resolve => (selectedPortfolio?: Portfolio) => resolve({ selectedPortfolio })
);
const addSecurityToPortfolio = createAction('addToPortfolio/ADD_SECURITY_TO_PORTFOLIO',
    resolve => (position: AddToPortfolioPosition, size: number, newPortfolioName?: string) => resolve({ position, size, newPortfolioName })
);

const setSubmittingProgress = createAction('addToPortfolio/SAVING_PROGRESS',
    resolve => (isSaving: boolean) => resolve({ isSaving })
);

const storeError = createAction('addToPortfolio/ERROR',
    resolve => (error?: ApiError) => resolve({ error })
);

export const addToPortfolioActions = {
    setPopupVisibility,
    addSecurityToPortfolio,
    setSelectedPortfolio,
    setSubmittingProgress,
    storeError,
    reset
};
